export default __webpack_public_path__ + "static/assembly-hero-d033753cec25712ba70ce195fa1a8c94.jpg";